"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.useConfiguration = void 0;
var _react = require("react");
var _configurationContext = require("../contexts/configurationContext");
const useConfiguration = ()=>(0, _react.useContext)(_configurationContext.ConfigurationContext);
exports.useConfiguration = useConfiguration;
